__webpack_require__.p = "/truisms/";